import styles from './FJImageItem.module.less';
import DeleteIcon from '../../../assets/svg/delete.svg?react';
import ComparisonIcon from '../../../assets/svg/comparison.svg?react';
import DownloadIcon from '../../../assets/svg/download.svg?react';
import FJCheckBox from '../../../common/components/FJCheckBox/FJCheckBox';
import ReloadIcon from '../../../assets/svg/reload.svg?react';
import AddToMediaIcon from '../../../assets/base64/media-gradient.js';
import classNames from 'classnames';
import FJResourceItemLoading from '../../../common/components/FJResourceItemLoading/FJResourceItemLoading';
import { useState, useEffect } from 'react';
import FJLocalStore from '../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import FJToolTip from '../../../common/components/FJToolTip/FJToolTip';
import FJUtil from '../../../util/FJUtil';
import FJMessageStore from '../../../store/FJMessageStore';
import FJLoading from '../../../common/components/FJLoading/FJLoading';
import FJIconButton from '../../../common/components/FJIconButton/FJIconButton';
import FJAppConstant from '../../../constants/FJAppConstant';

const FJImageItem = props => {
    const {
        appType,
        item,
        selected = false,
        isShowSelected = false,
        onSelected,
        onDelete,
        onDownload,
        onAddToMedia,
        reGenerate,
        onPreview,
        hideSelect = false,
        hideDelete = false,
        hideCompare = true,
        hideDownload = false,
        onEdit,
        hideEdit = true,
        isShowAddToMediaButton = false,
        onApplyMedia,
        isApplyButton = false,
        onReload,
    } = props;
    const { imgUrl, id, isLoading, isReload, originalUrl, videoUrl, status, width, height } = item;
    const [stateImgUrl, setStateImgUrl] = useState(imgUrl);
    const [stateOriginImgUrl, setStateOriginImgUrl] = useState(originalUrl);
    const [stateIsComparison, setStateIsComparison] = useState(false);

    const [stateIsImgLoading, setStateIsImgLoading] = useState(true);
    const [stateIsLoadError, setStateIsLoadError] = useState(false);
    const [stateOriginLoadingSuccess, setStateOriginLoadingSuccess] = useState(false);
    const [stateOriginLoadingError, setStateOriginLoadingError] = useState(false);
    const [stateIsDownloadLoading, setStateIsDownloadLoading] = useState(false);
    const [stateIsEditLoading, setStateIsEditLoading] = useState(false);

    const loading = stateIsImgLoading || isLoading;
    useEffect(() => {
        setStateImgUrl(imgUrl);
    }, [imgUrl]);

    const _sourceLoaded = () => {
        setStateIsImgLoading(false);
        setStateIsLoadError(false);
    };
    const _sourceError = () => {
        setStateIsImgLoading(false);
        setStateIsLoadError(true);
    };
    const _onReload = e => {
        e.stopPropagation();
        setStateIsImgLoading(true);
        setStateIsLoadError(false);
        setStateImgUrl(FJUtil.getReloadNewUrl(stateImgUrl));
        onReload && onReload(id);
    };
    const _onSelected = (bool, e) => {
        e.stopPropagation();
        onSelected && onSelected(id, bool, e);
    };
    const _reGenerate = e => {
        e.stopPropagation();

        reGenerate(id);
    };
    const _onPreview = e => {
        e.stopPropagation();
        if (stateIsImgLoading || isLoading || stateIsLoadError || isReload) return;
        onPreview(item);
    };
    const _onDelete = e => {
        e.stopPropagation();
        onDelete(id);
    };
    const _onEdit = e => {
        e.stopPropagation();
        setStateIsEditLoading(true);
        onEdit &&
            onEdit(item, () => {
                setStateIsEditLoading(false);
            });
    };
    const _onDownload = e => {
        e.stopPropagation();
        if (stateIsDownloadLoading) {
            return;
        }
        setStateIsDownloadLoading(true);
        onDownload && onDownload(id, () => setStateIsDownloadLoading(false));
    };
    // 添加到编辑页的媒体库
    const _onAddToMediaLibrary = e => {
        e.stopPropagation();
        onAddToMedia && onAddToMedia(imgUrl);
    };

    const _onApplyMedia = e => {
        e.stopPropagation();
        let options;
        if (width && height) {
            options = {
                size: { width: width, height: height },
            };
        }
        onApplyMedia && onApplyMedia(imgUrl, options);
    };

    const _onMouseDown = () => {
        if (stateIsLoadError || stateOriginLoadingError) {
            FJMessageStore.addMessage(FJLocalStore._('failed-to-preview-please-try-again'), 'error');
            setStateOriginImgUrl(FJUtil.getReloadNewUrl(originalUrl));
            return;
        }
        if (stateIsComparison || !stateOriginLoadingSuccess) return;
        setStateIsComparison(true);
        const _onMouseUp = () => {
            setStateIsComparison(false);
            FJUtil.removeEvent(document.body, 'mouseup', _onMouseUp);
        };
        FJUtil.addEvent(window, 'mouseup', _onMouseUp);
    };
    const _forbidEvent = e => {
        e.stopPropagation();
    };
    const _renderBtn = () => {
        const isShowCheck = !hideSelect && status !== 'progress';
        return (
            <>
                {isShowCheck && <FJCheckBox selected={selected} dataChange={_onSelected} className={styles.checkbox} />}
                {!isShowSelected && (
                    <div className={styles.header_right}>
                        {!hideCompare && (
                            <FJToolTip title={'compare'}>
                                <div
                                    className={styles.hover_icon_box}
                                    onMouseDown={_onMouseDown}
                                    onClick={_forbidEvent}
                                >
                                    <ComparisonIcon />
                                </div>
                            </FJToolTip>
                        )}
                        {!hideDelete && (
                            <FJToolTip title={'delete'}>
                                <div className={styles.hover_icon_box} onClick={_onDelete}>
                                    <DeleteIcon className={styles.delete_icon} />
                                </div>
                            </FJToolTip>
                        )}
                        {!hideDownload && (
                            <FJToolTip title={'download'}>
                                <div className={styles.hover_icon_box} onClick={_onDownload}>
                                    {stateIsDownloadLoading ? (
                                        <FJLoading style={{ width: 16, height: 16 }} />
                                    ) : (
                                        <DownloadIcon />
                                    )}
                                </div>
                            </FJToolTip>
                        )}
                        {isShowAddToMediaButton && (
                            <div
                                className={styles.add_to_media_button}
                                onClick={isApplyButton ? _onApplyMedia : _onAddToMediaLibrary}
                            >
                                <img src={AddToMediaIcon} className={styles.media_icon} />
                                <div className={styles.media_text}>
                                    {FJLocalStore._(isApplyButton ? 'apply' : 'media')}
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {!hideEdit && (
                    <FJIconButton
                        className={classNames(styles.use_this, {
                            [styles.use_this_loading]: stateIsEditLoading,
                            [styles.photo_remove_bg_edit]: appType === FJAppConstant.PHOTO_REMOVE_BG,
                        })}
                        textClassName={styles.use_this_text}
                        text={FJLocalStore._('edit')}
                        onClick={_onEdit}
                        isLoading={stateIsEditLoading}
                    />
                )}
            </>
        );
    };
    const _renderRetry = () => {
        const isVideoGenerator = appType === FJAppConstant.AI_VIDEO_GENERATOR;
        return (
            <div className={styles.new_retry_box}>
                {isVideoGenerator && (
                    <div className={styles.error_text}>
                        {FJLocalStore._('failed-to-generate-video-because-of-some-unknown-errors')}
                    </div>
                )}
                <div className={styles.retry_btn} onClick={_reGenerate}>
                    {FJLocalStore._('retry')}
                </div>
            </div>
        );
    };
    const _renderReload = () => {
        return (
            <div className={styles.retry_box}>
                <ReloadIcon className={styles.reload_icon} onClick={_onReload} />
            </div>
        );
    };

    const _renderWait = () => {
        return (
            <div className={styles.wait_box}>
                {item.generationType === 'iv' && item.originalUrl && (
                    <>
                        <img className={styles.bk_img} src={item.originalUrl} alt='' />
                        <div className={styles.mask} />
                    </>
                )}
                <div className={styles.content}>
                    <div className={styles.wait_title}>{FJLocalStore._('generating_')}</div>
                    <div
                        className={styles.wait_desc}
                        dangerouslySetInnerHTML={{ __html: FJLocalStore._('estimate-wait-time') }}
                    />
                </div>
            </div>
        );
    };

    const _onForbidDrag = e => {
        e.preventDefault();
        e.stopPropagation();
        return;
    };
    const _renderMain = () => {
        return (
            <>
                {_renderBtn()}
                {stateImgUrl && (
                    <img
                        className={classNames(styles.img_item, loading && styles.opacity_0)}
                        src={stateImgUrl}
                        onLoad={_sourceLoaded}
                        onError={_sourceError}
                        loading='lazy'
                        onDragStart={_onForbidDrag}
                    />
                )}
                {videoUrl && <video src={videoUrl} loop autoPlay />}
                {stateOriginImgUrl && (
                    <div
                        className={classNames(
                            styles.comparison_box,
                            stateIsComparison ? styles.show : styles.hide,
                            loading && styles.opacity_0,
                        )}
                    >
                        <img
                            className={classNames(styles.comparison_img)}
                            src={stateOriginImgUrl}
                            alt=''
                            onLoad={() => {
                                setStateOriginLoadingSuccess(true);
                                setStateOriginLoadingError(false);
                            }}
                            onError={() => {
                                setStateOriginLoadingSuccess(false);
                                setStateOriginLoadingError(true);
                            }}
                            loading='lazy'
                        />
                    </div>
                )}
            </>
        );
    };
    const _renderState = () => {
        if (status === 'progress') {
            return _renderWait();
        } else if (status === 'failed') {
            return _renderRetry();
        }
        const loading = stateIsImgLoading || isLoading;
        const loadError = stateIsLoadError;
        if (isReload) {
            return _renderRetry();
        } else if (loading) {
            return <FJResourceItemLoading className={styles.loading} />;
        } else if (loadError) {
            return _renderReload();
        }
    };
    return (
        <div className={classNames(styles.img_box, isShowSelected ? styles.selected : '')} onClick={_onPreview}>
            {_renderMain()}
            {_renderState()}
        </div>
    );
};
FJImageItem.propTypes = {
    appType: PropTypes.string,
    item: PropTypes.object,
    selected: PropTypes.bool,
    isShowSelected: PropTypes.bool,
    onSelected: PropTypes.func,
    onDelete: PropTypes.func,
    onDownload: PropTypes.func,
    onAddToMedia: PropTypes.func,
    reGenerate: PropTypes.func,
    onPreview: PropTypes.func,
    hideSelect: PropTypes.bool,
    hideDelete: PropTypes.bool,
    hideCompare: PropTypes.bool,
    hideDownload: PropTypes.bool,
    onEdit: PropTypes.func,
    hideEdit: PropTypes.bool,
    isShowAddToMediaButton: PropTypes.bool,
    onApplyMedia: PropTypes.func,
    isApplyButton: PropTypes.bool,
    onReload: PropTypes.func,
};
export default FJImageItem;
